export default "/packs/images/default_800x300~f37b62c68746f2706347041de3d98694.png";